// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2M851","legacyBtn":"MutateMid_legacyBtn__2a6oE"};